import React, { useState, useEffect } from 'react';
import PageTabTitle from '../../components/PageTabTitle';
import {
  Container,
  Typography,
  Box,
  CircularProgress,
  Alert,
  useTheme
} from '@mui/material';
import { DepartmentSection } from './DepartmentSection';
import { Department, ApiResponse } from './types';
import { httpRequest } from 'src/services/httpRequest';

export const SubscriptionPage: React.FC = () => {
  const [departments, setDepartments] = useState<Department[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
const theme = useTheme();

// Fetch departments on component mount
  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        setLoading(true);
        const response: ApiResponse = await httpRequest(
          'GET',
          '/townships/departments?IncludePermits=true&PermitStatus=Active'
        );
        if (response.status === 'success') {
          setDepartments(response.data.Data);
        } else {
          setError('Failed to fetch departments.');
        }
      } catch (err) {
        setError('An error occurred while fetching departments.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <React.Fragment>
      <PageTabTitle title="Subscriptions" />
      <Box px={3}>
        <Box sx={{ py: 3, borderRadius: 2, boxShadow: 2 }}>
          {error ? (
            <Box mb={3}>
              <Alert severity="error">{error}</Alert>
            </Box>
          ) : null}
          <Box
            sx={{
              backgroundColor: 'white',
              borderRadius: 1,
              boxShadow:
                'rgba(17, 17, 26, 0.05) 0px 1px 0px, rgba(17, 17, 26, 0.1) 0px 0px 8px'
            }}
          >
            <Box
              textAlign="center"
              sx={{
                backgroundColor: theme.palette.primary.main,
                borderRadius: '10px 10px 0 0',
                padding: 2,
                mb: 2,
              
              }}
            >
              <Typography
                variant="h2"
                component="h2"
                gutterBottom
                color="white"
                sx={{
                  fontSize: { xs: 'large', sm: 'x-large', md: 'xx-large' },
                  fontWeight: 600,
                  mb: 0 // Removed bottom margin since we only have one element
                }}
              >
                Permit Subscription Plans
              </Typography>
            </Box>
            <Typography
              variant="h5"
              textAlign="center"
              fontSize="xx-large"
              sx={{ color: 'primary.main' }}
            >
              <Box>
                <Container maxWidth="lg" sx={{ py: 2 }}>
                  {departments &&
                  departments?.length &&
                  departments[0]?.Permits?.length ? (
                    departments
                      ?.filter((department) => 
                        department?.DepartmentName === 'Department of Health or Animal Control'
                      )
                      ?.map((department) => (
                        <DepartmentSection
                          key={department?.DepartmentID}
                          department={department}
                        />
                      ))
                  ) : (
                    <Typography textAlign={'center'}>
                      Department details not found, please check after some
                      time.
                    </Typography>
                  )}
                </Container>
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};
